<template>
  <google-map
    v-if="fetched || filteredListings"
    :markers-data="markersData"
    :map-options="mapOptions"
    @search-nearby="nearbyListings"
  />
  <div v-else class="no-map">
    <img :src="grayMap" class="w-full pa-16" alt="gray map" />
  </div>
</template>

<script>
import { AMENITY_ICONS } from "@/consts/AMENITIES";
import { mapState, mapActions } from "vuex";
import MediaMixin from "@/mixins/media-mixin";
import FormattersMixin from "@/mixins/formatters-mixin";
import GoogleMap from "@/components/common/google-maps/google-map";
import debounce from "lodash/debounce";
import grayMap from "@/assets/images/gray-map.jpg";
import PLACEHOLDER from "@/assets/images/NEW_PLACEHOLDER.jpeg";

export default {
  name: "site-map",
  components: { GoogleMap },
  mixins: [MediaMixin, FormattersMixin],
  props: ["filteredListings"],
  data: () => ({
    AMENITY_ICONS,
    mapOptions: {
      center: { lat: 0, lng: 0 },
      zoom: 2,
      maxZoom: 18,
    },
    grayMap,
  }),
  computed: {
    ...mapState("listingsModule", ["listings", "fetched"]),
    markersData() {
      const url = new URL(window.location.href);
      return (this.filteredListings || this.listings)
        .filter((l) => l.lat)
        .map((l) => ({
          id: l.id,
          position: { lat: l.lat, lng: l.lng },
          price: l.extra_info?.current_price?.total_price,
          currency: l.get_currency,
          info: `
          <a href="/listing/${l.id}${
            url.search
          }" class="black--text text-decoration-none" target="_blank">
            <div class="google-map-info">
              <img class="google-map-info-image" src="${
                l.pictures[0]?.thumbnail ||
                l.pictures[0]?.original ||
                PLACEHOLDER
              }">
              <div class="google-map-info-content">
                    <div class="text-body-2 mb-1 font-weight-semibold">
                  ${l.city_name}
                </div>
                <div class="text-body-2 mb-2 grey--text text--darken-2">
                  ${l.title}
                </div>
                <div class="d-flex align-center font-weight-regular grey--text text--darken-2">
                  <div class="me-2">
                    <span>${l.accommodates}</span> ${this.$t("guests")}
                  </div>
                  |
                  <div class="mx-2">
                    <span>${l.beds}</span> ${this.$t("beds")}
                  </div>
                  |
                  <div class="mx-2">
                    <span>${l.baths}</span> ${this.$t("baths")}
                  </div>
                </div>
              </div>
            </div>
          </a>
        `,
        }));
    },
  },
  methods: {
    ...mapActions("listingsModule", ["getListings"]),
    amenitiesHTML(items) {
      return items
        .map(
          (
            item
          ) => `<div class="d-inline-flex align-center google-map-amenities-item mr-3">
                    <i class="mr-1">${AMENITY_ICONS[item.type]}</i>
                    <span>${item.count}</span>
                   </div>`
        )
        .join("");
    },
    nearbyListings: debounce(function (loc) {
      if (this.filteredListings) return;
      this.$router.push({
        name: "listings",
        query: {
          ...this.$route.query,
          nearby: true,
          ...loc,
        },
      });
    }, 500),
  },
};
</script>

<style scoped>
.no-map {
  border-left: solid 0.1rem #e7e7e7;
  opacity: 25%;
}
:deep(.gm-style-iw-chr) {
  position: absolute;
  right: 0;
}
:deep(.google-map-info) {
  width: 300px;
}
:deep(.google-map-info-image) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
:deep(.gm-style-iw-chr > button) {
  background-color: white !important;
  border-radius: 50%;
  transform: scale(0.65);
}
</style>
